<template>
  <div class="cpnt-cad-vis-dados-campo">
    <!-- SETA O TITULO RECEBIDO -->
    <label class="titulo">
      

      <!-- SETA O NOME DO CAMPO -->
      <span v-html="cpntTitulo"></span>
      <span>:</span>

      <!-- SETA O BOTÃO COPIAR -->
      <App-Button v-if="cpntCopiar !== null && [ '', null, undefined ].indexOf(cpntValor) === -1"
      :cpntIcone='"copiar"' 
      :cpntClass='[ "btn", "btn-default", "btn-sm" ]'
      :cpntExplica='{ mensagem: "Copiar" }'
      @onClick='cpntVisDadosCopiar'
      ></App-Button>
    </label>


    <!-- SETA O CONTEUDO -->
    <div class="conteudo">
      <!-- SETA  AIMAGEM QUE DEVE APRESENTAR NO CAMPO -->
        <img :src="cpntImagem" v-if="[ '', null, undefined ].indexOf(cpntImagem) === -1" />

        <!-- SETA O CONTEUDO -->
        <span v-html='cpntValor'></span>
    </div>
  </div>
</template>

<style scoped>
  /* TITULO */
  .cpnt-cad-vis-dados-campo > .titulo {
    margin: 0px;
  }
    .cpnt-cad-vis-dados-campo > .titulo > span {
      font-size: var(--font-base-soma-12);
      line-height: 16px;
      color: #0648cd;
    }

  /* BOTÃO COPIAR */
  .cpnt-cad-vis-dados-campo > .titulo > button {
    visibility: hidden;
    margin-left: 2px;
    padding: 0;
    border: none;
    background: none;
    width: 18px;
    height: 18px;
  }
  .cpnt-cad-vis-dados-campo:hover > .titulo > button {
    visibility: visible;
  }
  
  /* CONTEUDO */
  .cpnt-cad-vis-dados-campo > .conteudo {
    font-size: 14px;
    line-height: 16px;
    vertical-align: top;
    min-height: 16px;
    word-break: break-all;
  }
    .cpnt-cad-vis-dados-campo > .conteudo > img {
      margin-right: 5px;
      width: 22px;
      height: auto;
    }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: true,
        type: String
      },
      cpntImagem: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntValor: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntCopiar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    methods: {
      cpntVisDadosCopiar: function () {
        // INICIA A VARIAVEL COM OS PARAMETROS
        var params = {}

        // SETA O VALOR QUE SERÁ COPIADO
        params.valor = this.cpntValor

        // VERIFICA SE TEM QUE FAZER ALGUMA AÇÃO AO COPIAR
        switch (this.cpntCopiar) {
          case 'contato--cnpj_cpf':
          case 'contato--ie':
            params.tipo = 'numero'
            break
        }

        // FAZ A COPIA DOS DADOS SOLICITADOS
        this.$store.commit('FUN_COPIAR_VALOR', params)
      }
    }
  }
</script>
